import { Box } from '@mui/material';
import { format } from 'date-fns';
import React, { useState } from 'react';
import strings from '../../resources/strings';
import DatePickerInput from '../DatePickerInput/DatePickerInput';
import { FieldTextInput } from '../FieldTextInput';
import { PublishDatesProps } from './types';

const PublishDates: React.FC<PublishDatesProps> = (props) => {
    const [publishFrom, setPublishFrom] = useState(props.publishFrom ? new Date(props.publishFrom) : null);
    const [publishTo, setPublishTo] = useState(props.publishTo ? new Date(props.publishTo) : null);
    return (
        <Box
            sx={{
                width: '100%',
                padding: '0 2rem 0 2rem',
                display: props.visibility ? 'flex' : 'none',
                justifyContent: 'space-around',
                alignItems: 'center',
                margin: '3rem 0',
                gap: 2,
            }}
        >
            <DatePickerInput
                label={strings.newsAndEvents.dateFrom}
                value={publishFrom ? format(publishFrom, 'yyyy-MM-dd') : null}
                minDate={Date.now()}
                name="publishFrom"
                item={publishFrom}
                setItem={setPublishFrom}
            ></DatePickerInput>
            <DatePickerInput
                label={strings.newsAndEvents.dateTo}
                value={publishTo ? format(publishTo, 'yyyy-MM-dd') : null}
                minDate={Date.now()}
                name="publishTo"
                item={publishTo}
                setItem={setPublishTo}
            ></DatePickerInput>

            <FieldTextInput
                id="publishFrom"
                name="publishFrom"
                value={publishFrom ? format(publishFrom, 'yyyy-MM-dd') : undefined}
                required={false}
                variant="outlined"
                label={strings.newsAndEvents.dateFrom}
                type="text"
                hidden={true}
            />
            <FieldTextInput
                id="publishTo"
                name="publishTo"
                value={publishTo ? format(publishTo, 'yyyy-MM-dd') : undefined}
                required={false}
                variant="outlined"
                label={strings.newsAndEvents.dateTo}
                type="text"
                hidden={true}
            />
        </Box>
    );
};

export default PublishDates;
